import {types} from '../../types';

const setGetListFreespinAction = (payload) => {
    return {
        type: types.freespin.SET_LIST_FREESPIN,
        payload,
      }
}

export {
  setGetListFreespinAction as SetGetListFreespinAction
}
